import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { TypeFormats } from 'src/shared/types/exportItem';
import { SelectedColum } from '../models/challenge-user-details';

type DataChallenge = { 
  isLoading: boolean;
  showLoading: boolean;
  currentView: number;
  runningChallenges: any[];
  history: any[];
  localization: any[];
  localizedStrings: Map<string, string>;
}
@Injectable({
  providedIn: 'root'
})
export class ChallengesService {

  data: DataChallenge = {
    isLoading: false,
    showLoading: true,
    currentView: 0,
    runningChallenges: [],
    history: [],
    localization: [],
    localizedStrings: new Map(),
  }
  private translationsLoaded = new Subject<void>();

  constructor(
    private cvApiService: CVApiService,
    private cvLocalizationService: CVLocalizationService
  ) {
    Promise.all([
    this.cvLocalizationService.GetSection("Challenges"),
    this.cvLocalizationService.GetSection("Leaderboard_Module")
    ]).then(([challenges, leaderboard]) => {
        this.data.localizedStrings = new Map([
            ...this.data.localizedStrings,
            ...challenges,
            ...leaderboard
        ]);
        this.translationsLoaded.next();
    }).catch(error => console.error("Error loading translations:", error));
  }

  get translations() {
    return this.translationsLoaded.asObservable();
  }

  async loadMetricSelector(copy?: boolean) {
    try {
      let uri = "/api/v1/gamification/challenges/metric-selector";

      if (copy) {
        uri += "?copy=true";
      }

      let response = await this.cvApiService.get(uri);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loadinng metric selector: " + error.message);
    }
  }

    async loadRunningChallenges(isCxone: boolean = false) {
        this.data.isLoading = true;
        try {
            let url = "/api/v1/gamification/challenges/active?admin=true";
            
            if (isCxone) {
                url = "/api/v2/gamification/challenges/active?admin=true&isFirstLoad=true&isCXone=true";
            }
            let response: any = await this.cvApiService.get(url);

            if (response.status_code == 200) {
                this.data.isLoading = false;
                this.data.showLoading = false;
                this.data.runningChallenges = response.data.RunningChallenges;
            } else {
                throw response;
            }
        } catch (error) {
            showErrorMessage("Error loading running challenges: " + error.message);
        }
    }

  async loadChallengesHistory() {
    try {
      const url = "/api/v1/gamification/challenges/history?admin=true";
      let response: any = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.history = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading challenge history: " + error.message);
    }
  }

  async loadChallengesUserDetails<T>(
    options: {
      format: 'excel' | 'csv' | 'png';
      ChallengeID?: number;
      selectedColums: SelectedColum[];
      data: T,
      startDate: Date,
      endDate: Date,
      shortBody?: string,
    }, isCXone: boolean = false) {
    if (!options.ChallengeID) return '';
    try {
      const url = `/api/v1/challengesuser/export?isCXone=${isCXone}`;
      const response = await this.cvApiService.post<string>(url, options);

      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error downloading file " + error.message);
    }
    return '';
  }

  async loadChallengesSettings() {
    try {
      const url = "/api/v1/gamification/challenge-settings";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading challenges settings: " + error.message);
    }
  }

  async saveChallengesSettings(challengeSettings: any) {
    try {
      const url = "/api/v1/gamification/challenge-settings";
      let response = await this.cvApiService.post(url, JSON.stringify(challengeSettings));

      if (response.status_code >= 200 && response.status_code < 300) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving challenges settings: " + error.message);
    }
  }

  async saveSelectorState(metrics: string, loginID: number) {
    try {
      const url = "/api/v1/gamification/challenges/selector-state/" + loginID;
      let response = await this.cvApiService.put(url, JSON.stringify(metrics));

      if (response.status_code >= 200 && response.status_code < 300) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving challenges settings: " + error.message);
    }
  }


  async activeChallengeExportFile(format: TypeFormats, activeChallengeGridDataObject: string, isCXone: boolean = false) {
    try {
      const url = `/api/v1/challenges/active/export?format=${format}&isCXone=${isCXone}`;
      const response = await this.cvApiService.post<string>(url, activeChallengeGridDataObject);
      if (response.status_code >= 200 && response.status_code < 300)
        return response;
      else throw response.warnings;
    } catch (err) {
      throw err;
    }
  }

  async getHistoryChanllengeExportFile(format: TypeFormats, historyChallengeGridDataObject: string) {
    try {
      const url = `/api/v1/challenges/history/export?format=${format}`;
      const response = await this.cvApiService.post<string>(url, historyChallengeGridDataObject);
      if (response.status_code >= 200 && response.status_code < 300)
        return response;
      else throw response.warnings;
    } catch (err) {
      throw err;
    }
  }
}
